.switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 38px;
  padding: 12px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  background: none;
  border: none;
  appearance: none;
}

.input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: inherit;
  z-index: 1;
}

.switchTrack {
  width: 34px;
  height: 14px;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-palette-action-active);
  opacity: 0.38;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition:
    opacity var(--tuna-transitions-duration-shortest) var(--tuna-transitions-easing-easeInOut),
    background-color var(--tuna-transitions-duration-shortest) var(--tuna-transitions-easing-easeInOut);
}

.input:checked ~ .switchTrack {
  background-color: var(--tuna-palette-primary-main);
  opacity: 0.5;
}

.thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: currentColor;
  box-shadow: var(--tuna-shadow-1);
  position: absolute;
  top: 9px;
  left: 9px;
  transition: left var(--tuna-transitions-duration-shortest) var(--tuna-transitions-easing-easeInOut);
  color: var(--tuna-palette-grey-50);
}

.input:checked ~ .thumb {
  left: 29px;
  color: var(--tuna-palette-primary-main);
}

.input:focus-visible ~ .thumb {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.input:disabled ~ .switchTrack,
.input:disabled ~ .thumb {
  opacity: 0.38;
}

.input:disabled {
  cursor: default;
}
